import React from 'react';
import PropTypes from 'prop-types';

const Card = ({
  icon,
  title,
  description,
  className = '',
  iconClassName = ''
}) => {
  return (
    <div className={`flex flex-col ${className}`}>
      {/* Icon and Title Row */}
      <div className="flex items-center gap-2">
        {icon && (
          <img src={icon} alt={title} className={`h-7 w-7 rounded-[14px] mt-0.5 ${iconClassName}`} />
        )}
        <h3 className="text-[20px] font-semibold text-[#1d263e] leading-[25px]">
          {title}
        </h3>
      </div>

      {/* Description Row */}
      <p className="text-[16px] text-[#202a44] leading-6 mt-2 pl-8">
        {description}
      </p>
    </div>
  );
};

Card.propTypes = {
  icon: PropTypes.string,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  className: PropTypes.string,
  iconClassName: PropTypes.string
};

export default Card;
